<template>
    <!-- 卡片组件 -->
    <el-card
    class="vel-card" 
    :body-style="byStyle"
    :shadow="shadow"
    :style="style"
    >   
        <!-- 卡片头部 -->
        <div v-if="header" class="vel-card-header" slot="header">
            <slot name="header">
                <h4>{{headerTitle}}</h4>
                <VelBtn :type="type" :icon="icon" :btnText="headerText" @btnClick="actionFn" />
            </slot>
        </div>
        <!-- 卡片默认插槽 -->
        <slot></slot>
        <!-- 卡片操作 -->
        <div v-if="action" class="vel-card-action">
            <template v-for="(ac,acIndex) in actionList">
                <div class="vel-card-action-cnt" :key="ac.key">
                    <VelIcon :iconName="ac.icon" :type="ac.type" @click.native="actionFn(ac.key)" />
                </div>
                <span v-if="!(acIndex===actionList.length-1)" :key="ac + acIndex" />
            </template>
        </div>
    </el-card>
</template>
<script>
import VelBtn from '../button'
import VelIcon from '../icon'
export default {
    name:"VelCard",
    components:{
        VelBtn,
        VelIcon,
    },
    props:{
        isHeader:Boolean,
        isAction:Boolean,
        isInlineBlock:Boolean,
        headerTitle:String,
        icon:String,
        headerText:String,
        bodyStyle:Object,
        shadow:String,
        isClearBodyStyle:Boolean,
        type:{
            type:String,
            default:'text'
        },
        actionList:{
            type:Array,
            default: () =>{
                return [
                    {key:'set',icon:'el-icon-s-tools',type:'primary'},
                    {key:'del',icon:'el-icon-delete-solid',type:'primary'},
                    {key:'more',icon:'el-icon-more',type:'primary'},
                ]
            }
        }
    },
    data() {
        return {
            header:false,
            action:false,
            style:{
                display:''
            },
            byStyle:{
                padding:'20px'
            }
        };
    },
    watch:{
        bodyStyle:{
            handler(newval){
                if(!newval) return
                this.byStyle = newval
            },
            deep:true,
            immediate:true,
        }
    },  
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isHeader ? this.header = true : this.header
            this.isAction ? this.action = true : this.action
            this.isAction || this.isInlineBlock ? this.byStyle = {padding:0} : this.byStyle = this.bodyStyle
            this.isInlineBlock ? this.style.display = 'inline-block' : this.style
            this.isClearBodyStyle ? this.byStyle = {padding:0} : this.byStyle
        },
        actionFn(type){
            this.$emit('actionFn',type)
        }
    }
}
</script>
<style scoped>
.vel-card-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.vel-card-action{
    display: flex;
    align-items: center;
    border-top: 1px solid #ccc;
    font-size: 17px;
    color: #409eff;
}
.vel-card-action>div{
    flex: 1;
    display: flex;
    padding: 10px 0;
    justify-content: center;
}
.vel-card-action>span{
    width: 1px;
    height: 20px;
    background: #ccc;
}
.vel-card-action-cnt{
    cursor: pointer;
}
</style>